import React, {useEffect, useContext } from "react";
import Header from "../components/Header";
import { RootStoreContext } from "../store/rootStore";

import { observer } from "mobx-react-lite";
import CoCurricularFilters from "../components/CoCurricularFilters";
import CoCurricularCards from "../components/CoCurricularCards";

import Modal from "../components/Modal";
import CoCurricularCardDetail from "../components/CoCurricularCardDetail";


const CoCurricularWall:React.FC = observer(() => {

  const rootStore = useContext(RootStoreContext);
  const {ccCardChosen, ccSetCardChosen} = rootStore.coCurricularStore;

  return (
    <>
      <Header />
      <CoCurricularFilters />
      <CoCurricularCards />

      <Modal isOpen={ccCardChosen != null} closeModal={() => ccSetCardChosen(null)} columns={1}>
        <CoCurricularCardDetail />
      </Modal>

    </>
  );

});

export default CoCurricularWall;